<template>
  <div class="teams-carousel_slide">
    <carousel-3d
      ref="team-carousel"
      :controls-visible="true"
      :controls-prev-html="'<span class=\'theme-left\'></span>'"
      :controls-next-html="'<span class=\'theme-right\'></span>'"
      :clickable="false"
      :loop="true"
      :height="getPromoConfig.loggedIn || getPromoConfig.isLoggedIn ? 400 : 350"
      :width="300"
      :count="content.length"
      @after-slide-change="onAfterSlideChange"
      @before-slide-change="onBeforeSlideChange"
    >
      <slide v-for="(team, i) in content" :key="i" :index="i">
        <div class="pt-team-wrapper">
          <img
            height="302"
            @error.once="handleImageError"
            :src="
              `//media.itsfogo.com/media/mkt-content/img/jerseys/200x200/${
                team.externalTeamId
              }.png`
            "
          />
          <div
            class="pt-selected-team__wrapper"
            v-if="getPromoConfig.loggedIn || getPromoConfig.isLoggedIn"
          >
            <div
              class="pt-selected-team"
              v-if="
                !animationInProgress &&
                  activeSlideIndex === i &&
                  (getUserPick !== null &&
                    getUserPick.domestic.teamid === team.id)
              "
            >
              {{ config.FieldValues.Parameters.label_selected }}
              {{ getProperTeamData.name }}.<br />
              <b>{{ config.FieldValues.Parameters.label_selected_2 }}</b>
            </div>
          </div>
          <div
            v-if="inProgress && TeamDetails.name == team.name"
            class="centered lds-ring"
          ></div>
        </div>
        <div
          class="pt-select-team__wrapper"
          :class="{
            'pt-select-team__wrapper--animation':
              !animationInProgress &&
              activeSlideIndex === i &&
              (getPromoConfig.loggedIn || getPromoConfig.isLoggedIn)
          }"
        >
          <div class="team-name" v-html="team.name"></div>
          <div class="pt-select-team__button__wrapper">
            <button
              class="pt-select-team no-uniform"
              :disabled="
                getUserPick !== null && getUserPick.domestic.teamid === team.id
              "
              :class="{
                'pt-select-team--visible':
                  (getPromoConfig.loggedIn || getPromoConfig.isLoggedIn) &&
                  (!animationInProgress && activeSlideIndex === i)
              }"
              @click="TeamSelection(team)"
            >
              {{ config.FieldValues.Parameters.label_select }}
            </button>
            <button
              class="pt-edit-state-close no-uniform"
              :class="{
                'pt-edit-state-close--visible':
                  (getPromoConfig.loggedIn || getPromoConfig.isLoggedIn) &&
                  (!animationInProgress && activeSlideIndex === i) &&
                  getEditState
              }"
              @click="closeEditView"
            >
              {{ config.FieldValues.Parameters.label_close }}
            </button>
          </div>
        </div>
      </slide>
    </carousel-3d>
    <template v-if="select">
      <div class="selection-popup">
        <span @click="popUpEnd" class="selection-popup-close theme-ex"></span>
        <div class="selection-popup-message">
          {{ config.FieldValues.Parameters.selection_message_1 }} "{{
            TeamDetails.name
          }}" {{ config.FieldValues.Parameters.selection_message_2 }}
        </div>
        <button class="pt-button" @click="submit">
          {{ config.FieldValues.Parameters.label_submit }}
        </button>
      </div>
    </template>
  </div>
</template>
<script>
import Vue from "vue";
import store from "@/store/store";
import { mapGetters } from "vuex";
import { Carousel3d, Slide } from "vue-carousel-3d";
Vue.use(Carousel3d);
export default {
  props: {
    config: Object,
    content: Array,
    selectedSlide: Number
  },
  name: "teams",
  data() {
    return {
      slides: 5,
      select: false,
      TeamDetails: Object,
      inProgress: false,
      activeSlideIndex: 0,
      animationInProgress: false,
      BASE_PATH: "http://media.itsfogo.com/media/upload/live/players/4/"
    };
  },
  computed: {
    ...mapGetters([
      "getEditState",
      "getFocusedCharacter",
      "getPromoConfig",
      "getSelectedTeams",
      "getUserPick",
      "getLeagueViewData"
    ]),
    getProperTeamData() {
      const league = this.getLeagueViewData.find(
        item => item.id === this.getUserPick.domestic.leagueid
      );
      return league.teams.find(
        item => item.id === this.getUserPick.domestic.teamid
      );
    }
  },
  components: {
    Carousel3d,
    Slide
  },
  methods: {
    closeEditView() {
      store.commit("setEditState", false);
    },
    TeamSelection(team) {
      this.select = true;
      this.TeamDetails = team;
    },
    submit() {
      this.select = false;
      this.inProgress = true;
      store.dispatch("sendLeagueData", this.TeamDetails);
    },
    popUpEnd() {
      this.select = false;
    },
    onBeforeSlideChange() {
      this.animationInProgress = true;
    },
    onAfterSlideChange(index) {
      this.animationInProgress = false;
      this.activeSlideIndex = index;
    },
    goToSlide(index) {
      this.$refs["team-carousel"].goSlide(index);
    },
    handleImageError(e) {
      e.target.src =
        "//media.itsfogo.com/media/mkt-content/img/jerseys/200x200/fallback.png";
    }
  },
  watch: {
    getFocusedCharacter(val) {
      console.log("selection changed", val);
      const slideIndex = this.content.findIndex(
        item => item.name.charAt(0) === val
      );
      this.goToSlide(slideIndex);
    }
  },
  mounted() {
    const slideIndex = this.content.findIndex(
      item => item.id === this.selectedSlide
    );
    this.goToSlide(slideIndex);
  }
};
</script>

<style lang="scss">
.pt-promo-wrapper {
  .teams-carousel_slide {
    .carousel-3d-slide {
      background-color: transparent;
      border: none;
      filter: brightness(50%);
      overflow: visible;
      text-align: center;
      transition: filter 500ms ease 0s, transform 500ms ease 0s,
        opacity 500ms ease 0s, visibility 500ms ease 0s !important;
      &.current {
        filter: brightness(100%);
      }
    }

    .carousel-3d-container {
      box-sizing: content-box;
      margin: 20px auto 0;
      .prev {
        left: 20px;
        color: var(--pyt-carousel-icon-color);
        font-size: 25px;
      }
      .next {
        right: 20px;
        color: var(--pyt-carousel-icon-color);
        font-size: 25px;
      }
    }
  }
}

.centered {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-decoration: underline;
  cursor: pointer;
  color: goldenrod;
}

.team-name {
  color: var(--pyt-carousel-team-name-color);
  font-family: "Roboto Condensed";
  font-weight: bold;
  letter-spacing: 3px;
  margin-bottom: 10px;
  text-transform: uppercase;
  text-align: center;
}
.selection-popup {
  background-color: var(--pyt-select-message-bg);
  border-radius: 4px;
  box-shadow: var(--pyt-select-message-shadow);
  display: flex;
  flex-direction: column;
  left: calc(50% - 160px);
  max-width: 320px;
  padding: 10px;
  position: absolute;
  top: 35%;
  width: 80%;
}

.pt-edit-state-close {
  background: none;
  border: var(--pyt-button-close-border);
  border-radius: 4px;
  color: var(--pyt-button-close-color);
  cursor: pointer;
  display: none;
  font-size: 13px;
  font-weight: 500;
  margin-left: 10px;
  padding: 8px 28px;
  transition: visibility 0s ease-out 0.25s;
  visibility: hidden;

  &--visible {
    display: block;
    visibility: visible;
  }

  &:hover {
    color: var(--pyt-button-close-hover-color);
  }
}

.pt-select-team {
  background: var(--pyt-button-bg);
  border-radius: 4px;
  color: var(--pyt-button-color);
  cursor: pointer;
  display: none;
  font-size: 13px;
  font-weight: 500;
  padding: 8px 28px;
  transition: visibility 0s ease-out 0.25s;
  visibility: hidden;

  &--visible {
    display: block;
    visibility: visible;
  }

  &:hover {
    background: var(--pyt-button-bg--hover);
  }

  &:disabled {
    background: var(--pyt-button-bg);
    opacity: 0.4;
  }

  &__button__wrapper {
    display: flex;
  }

  &__wrapper {
    box-sizing: border-box;
    display: inline-block;
    padding: 10px 20px;
    position: relative;

    &::before,
    &::after {
      box-sizing: inherit;
      content: "";
      position: absolute;
      // Set border to invisible, so we don't see a 4px border on a 0x0 element before the transition starts
      border: 1px solid transparent;
      width: 0;
      height: 0;
      z-index: -1;
    }

    // This covers the top & right borders (expands right, then down)
    &::before {
      top: 0;
      left: 0;
    }

    // And this the bottom & left borders (expands left, then up)
    &::after {
      bottom: 0;
      right: 0;
    }

    &--animation {
      &::before,
      &::after {
        width: 100%;
        height: 100%;
      }

      &::before {
        border-top-color: var(
          --pyt-select-wrapper-border-color
        ); // Make borders visible
        border-right-color: var(--pyt-select-wrapper-border-color);
        transition: border-color 0s ease-out 0.25s, width 0.25s ease-out 0.25s,
          // Width expands first
            height 0.25s ease-out 0.5s; // And then height
      }

      &::after {
        border-bottom-color: var(
          --pyt-select-wrapper-border-color
        ); // Make borders visible
        border-left-color: var(--pyt-select-wrapper-border-color);
        transition: border-color 0s ease-out 0.75s,
          // Wait for ::before to finish before showing border
            width 0.25s ease-out 0.75s,
          // And then exanding width
            height 0.25s ease-out 1s; // And finally height
      }
    }
  }
}

.pt-selected-team {
  background: var(--pyt-selected-message-bg);
  border-radius: 4px;
  color: var(--pyt-selected-message-color);
  margin: 0 auto;
  padding: 10px;
  width: 120px;

  &__wrapper {
    position: absolute;
    text-align: center;
    top: 25%;
    width: 100%;
  }
}

.selection-popup-message {
  color: var(--pyt-select-message-color);
  margin: 10px;
}

.selection-popup-close {
  align-self: flex-end;
  color: var(--pyt-select-message-color);
  cursor: pointer;
  font-size: 12px;
}

.teams-carousel_slide {
  display: flex;
  position: relative;
}

.carousel-3d-slider {
  height: 80% !important;
}
.lds-ring {
  display: inline-block;
  position: absolute;
  width: 64px;
  height: 64px;
  background-color: black;
  top: 50%;
}

.lds-ring div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 51px;
  height: 51px;
  margin: 6px;
  border: 6px solid #fff;
  border-radius: 50%;
  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
  border-color: goldenrod transparent transparent transparent;
}
.lds-ring div:nth-child(1) {
  animation-delay: -0.45s;
}
.lds-ring div:nth-child(2) {
  animation-delay: -0.3s;
}
.lds-ring div:nth-child(3) {
  animation-delay: -0.15s;
}
@keyframes lds-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
